import './PageContent.less';
import React, {useContext} from 'react';
import ErrorContext from "../../contexts/error/ErrorContext";
import DefaultFooter from "./default-footer/DefaultFooter";
import MainArea from "./main-area/MainArea";
import ErrorBoundary from "./error-boundary/ErrorBoundary";
import SimpleFooter from "./simple-footer/SimpleFooter";
import {LAYOUT_DASHBOARD} from "../Layout";
import {useLocation} from 'react-router-dom';


export default function PageContent({content, layoutType}) {
    const location = useLocation();

    const errorContext = useContext(ErrorContext);

    const footer = () => {
        if (layoutType === LAYOUT_DASHBOARD) {
            return <SimpleFooter/>;
        }

        return <DefaultFooter/>;
    };

    return <div className="page-content" key={location.pathname}>
        {
            errorContext.error === null &&
            <>
                <MainArea content={content} layoutType={layoutType}/>
                {footer()}
            </>
        }
        {
            errorContext.error !== null &&
            <ErrorBoundary error={errorContext.error}/>
        }
    </div>;
}
